// Home.js

import React, { useEffect } from 'react';
import logoSNC from '../assets/images/logoSNC.png';
import appStore from '../assets/images/app_store.png';
import googlePlay from '../assets/images/google_play.png';
import { useParams } from 'react-router-dom';

const Home = () => {

    const params = useParams();

    const appStoreLink = process.env.REACT_APP_APP_STORE;
    const googlePlayLink = process.env.REACT_APP_GOOGLE_PLAY;
    const sncLink = process.env.REACT_APP_SNC;
    const deepLink = process.env.REACT_APP_DEEP_LINK;


    useEffect(() => {
        console.log('params:', params);
        console.log('params links:', params.link);

        if (params.link) {
            console.log('app link:', `${deepLink}/?${params.link}`);
            window.location.href = `${deepLink}/?${params.link}`;
        }
    }, []);


    const handleClick = (externalLink) => {
        window.open(externalLink, '_blank');
    };

    return (
        <div className="home-container">
            <img src={logoSNC} alt="Logo" className="logo-image" />
            <h1 className="title">¡Actualiza tu app!</h1>
            <p className="description">Con la opción PEDIDOS, ahora puedes pedir a domicilio tus postres y bebidas favoritas o recogerlas en nuestros locales. Gana estrellas y saldo Sweet&Coffee® con tus consumos.</p>
            <button className="action-button" onClick={() => handleClick(sncLink)}>Inicio</button>
            <p className="footer">Descárgala en:</p>
            <div className="image-container">
                <img src={appStore} alt="App Store" className="side-by-side-image" onClick={() => handleClick(appStoreLink)} />
                <img src={googlePlay} alt="Google Play" className="side-by-side-image" onClick={() => handleClick(googlePlayLink)} />
            </div>
        </div>
    );
};

export default Home;
